export function createTableHolds(http) {
    const holds = new Map();
    let closed = false;
    const keyFor = (url, params) => `${url}:${params.date}`;

    function release(hold) {
        if (!hold.releasing) {
            hold.releasing = hold.pending
                .then(() => http.delete(hold.url, { params: { date: hold.params.date } }))
                .then((response) => {
                    if (holds.get(hold.key) === hold) holds.delete(hold.key);
                    return response;
                })
                .finally(() => {
                    hold.releasing = null;
                });
        }
        return hold.releasing;
    }

    return {
        reserve(url, params) {
            if (closed) return Promise.reject(new Error("The reservation form is closed."));
            const key = keyFor(url, params);
            const existing = holds.get(key);
            if (existing) {
                if (existing.releasing) return existing.releasing.then(() => this.reserve(url, params));
                return existing.pending;
            }
            const hold = { key, url, params: { ...params }, releasing: null };
            hold.pending = http.post(url, null, { params: hold.params }).catch((error) => {
                if (holds.get(key) === hold) holds.delete(key);
                throw error;
            });
            holds.set(key, hold);
            return hold.pending;
        },
        release(url, params) {
            const hold = holds.get(keyFor(url, params));
            return hold ? release(hold) : Promise.resolve();
        },
        close() {
            closed = true;
            return Promise.allSettled([...holds.values()].map((hold) => release(hold).catch(() => release(hold))));
        },
    };
}
